import { CellProps, Checkbox, SelectPicker, Table } from "rsuite";

const { Cell } = Table;

export const CheckBoxCell = ({ rowData, dataKey, ...props }: CellProps<any>) => {
  const isChecked = rowData && dataKey && !!rowData[dataKey];

  return (
    <Cell align="center" {...props}>
      <Checkbox checked={isChecked} readOnly />
    </Cell>
  );
};

export const SelectPickerCell = ({
  rowData,
  dataKey,
  data,
  ...props
}: CellProps<any> & { data: { value: string; label: string }[] }) => {
  const value = rowData && dataKey && (rowData[dataKey] as string);

  return (
    <Cell {...props}>
      <SelectPicker
        data={data}
        value={value}
        size="xs"
        cleanable={false}
        block
        className="me-2"
      />
    </Cell>
  );
};

export const SerialCell = ({ rowData, dataKey, ...props }: CellProps<any>) => {
  const value = (rowData && dataKey && rowData[dataKey]) as number;

  return (
    <Cell {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="20px"
        height="20px"
      >
        <path
          fill="#00ccf2"
          d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
        />
        <path
          fill="#fff"
          d="M34.602,14.602L21,28.199l-5.602-5.598l-2.797,2.797L21,33.801l16.398-16.402L34.602,14.602z"
        />
      </svg>
      <span className="ms-2">{`${value}`.padStart(3, "0")}</span>
    </Cell>
  );
};
